import { jsxs, jsx } from "react/jsx-runtime";
import { useGraphiQL } from "../provider.js";
/* empty css          */
const StatusBarView = ({
  isConnected,
  typeCount,
  pluginCount,
  cursorPosition,
  encoding = "UTF-8",
  indent = "Spaces: 2"
}) => /* @__PURE__ */ jsxs("footer", { className: "graphiql-status-bar", role: "contentinfo", children: [
  /* @__PURE__ */ jsx("span", { className: `graphiql-status-bar-conn${isConnected ? " connected" : " disconnected"}`, children: isConnected ? "Connected" : "Disconnected" }),
  isConnected && /* @__PURE__ */ jsxs("span", { className: "graphiql-status-bar-types", children: [
    typeCount,
    " types"
  ] }),
  pluginCount > 0 && /* @__PURE__ */ jsxs("span", { className: "graphiql-status-bar-plugins", children: [
    pluginCount,
    " ",
    pluginCount === 1 ? "plugin" : "plugins"
  ] }),
  /* @__PURE__ */ jsx("span", { className: "graphiql-status-bar-spacer" }),
  cursorPosition && /* @__PURE__ */ jsxs("span", { children: [
    "Ln ",
    cursorPosition.line,
    ", Col ",
    cursorPosition.column
  ] }),
  /* @__PURE__ */ jsx("span", { children: encoding }),
  /* @__PURE__ */ jsx("span", { children: indent }),
  /* @__PURE__ */ jsx("span", { children: "GraphQL" })
] });
const StatusBar = (props) => {
  const schema = useGraphiQL((state) => state.schema);
  const plugins = useGraphiQL((state_0) => state_0.plugins);
  const isConnected = schema != null;
  const typeCount = schema ? Object.keys(schema.getTypeMap()).length : 0;
  return /* @__PURE__ */ jsx(StatusBarView, { ...props, isConnected, typeCount, pluginCount: plugins.length });
};
export {
  StatusBar,
  StatusBarView
};
//# sourceMappingURL=index.js.map
